export const chargebackEn = {
  FULL: 'Full',
  PART: 'Part',
  CHARGEBACKS: 'Chargebacks',
  CHARGEBACK: 'Chargeback',
  APPLY_CHARGEBACK: 'Apply Chargeback',
  APPLY_WRITE_OFF: 'Apply Write Off',
  CHARGEBACK_APPLICATION_CONFIRMATION: 'Are you sure that you want to apply this chargeback to these invoices?',
  WRITE_OFF_APPLICATION_CONFIRMATION: 'Are you sure that you want to apply this write off to these invoices?',
  CHARGEBACK_FA_APPLICATION_CONFIRMATION: 'Are you sure that you want to apply this chargeback to these fuel advances?',
  CHARGEBACK_ASSIGN_SUCCESSFULLY: 'Chargeback assigned successfully',
  WRITE_OFF_ASSIGN_SUCCESSFULLY: 'Write off applied successfully',
  CHARGEBACK_SELECTED_INVOICES: 'Chargeback is going to be applied to the selected invoices:',
  WRITE_OFF_SELECTED_INVOICES: 'Write off is going to be applied to the selected invoices:',
  ADD_NOTES: 'Add notes:',
  ADD_NOTES_BUTTON: 'Add Notes',
  ADD_NOTES_HERE: 'Add notes here...',
  TOTAL_INVOICE_BALANCE: 'Total Invoice Balance:',
  TOTAL_CHARGEBACK_AMOUNT: 'Total Chargeback Amount:',
  TOTAL_WRITE_OFF_AMOUNT: 'Total Write Off Amount:',
  NEW_BALANCE: 'New Balance:',
  UNAPPLIED_FUND: 'Unapplied Fund',
  NO_INVOICE_SELECTED: 'No invoices selected',
  ONE_INVOICE_SELECTED: 'One invoice selected',
  MULTIPLE_INVOICE_SELECTED: '{amount} invoices selected',
  CONFIRM_APPLY_CHARGEBACK: 'Confirm Apply Chargeback',
  UNDER_MESSAGE_CHARGEBACK: 'The total invoices payment is less than payment total.',
  OVER_MESSAGE_CHARGEBACK: 'The total invoices payment exceeds payment total.',
  OVER_MESSAGE_CHARGEBACK_AMOUNT: 'The total chargeback amount exceeds total invoice balance.',
  OVER_MESSAGE_WRITE_OFF_AMOUNT: 'The total write off amount exceeds total invoice balance.',
  TOTAL_CHARGEBACKS_AMOUNT: 'Total Chargebacks Amount',
  TYPE: 'Type',
  AMOUNT: 'Amount',
  CONFIRM_APPLY_WRITE_OFF: 'Confirm Apply Write Off',
  WRITE_OFF_PERMISSION_REQUIRED: 'You do not have permission to create write offs.',
  WRITE_OFFS_COMING_SOON: 'Write offs for Fuel Advances are coming soon.',
  COMING_SOON_TITLE: 'Coming Soon!',
  COMING_SOON_DESCRIPTION: "You'll be able to use this feature in an upcoming update.",
  //START Patricio
  FUNDING_CHARGEBACK: 'Funding Chargeback',
  FUNDING_CHARGEBACK_INVOICE_TITLE: 'Invoice - Auto Apply Chargeback',
  FUNDING_CHARGEBACK_INVOICE_DESCRIPTION: 'Enable Chargebacks on Invoice Purchase.',
  FUNDING_CHARGEBACK_FUEL_ADVANCE_TITLE: 'Fuel Advance - Auto Apply Chargeback',
  FUNDING_CHARGEBACK_FUEL_ADVANCE_DESCRIPTION: 'Enable Chargebacks on Fuel Advance.',
  FUNDING_CHARGEBACK_MAX_AMOUNT_ALLOWED: 'The maximum amount allowed to pay is $ {amount}.',
  CREDITS: 'Credits',
  CREDIT_BALANCE: 'Credit Balance',
  RELEASE_CREDIT: 'Release Credit',
  TOTAL_CREDIT_AMOUNT: 'Total Credit Amount:',
  CONFIRM_RELEASE_CREDIT: 'Confirm Release Credit',
  RELEASE_CREDIT_SUCCESSFULLY: 'Credit released successfully',
  NO_CREDITS_SELECTED: 'No credits selected',
  RELEASE_CREDIT_DIALOG_DESC:
    'You are about to release the selected invoice credits to the client’s Cash Reserve as a chargeback. Once released, the credits will be closed with a $0.00 balance.',
  SELECTED_INVOICES_COUNT: 'Selected invoices',
  //END Patricio
  //START Michael
  CHARGEBACKS_FUEL_ADVANCES: 'Chargebacks Fuel Advances',
  CHARGEBACKS_OVER_ADVANCES: 'Chargebacks Over Advances',
  SEARCH_FUEL_ADVANCE: 'Search Fuel Advance',
  SEARCH_OVER_ADVANCE: 'Search Over Advance',
  SEARCH_CREDIT: 'Search Credit',
  TOTAL_CREDITS_AMOUNT: 'Total Credits Amount',
  REF_NO: 'Ref no',
  //END Michael
  FUEL_ADVANCE_AUTO_ATTACH_TITLE: 'Fuel Advance Auto Attach',
  FUEL_ADVANCE_AUTO_ATTACH_DESCRIPTION:
    'Choose which Fuel Advance types are pre-selected when the Approve for Funding screen opens.',
  FUEL_ADVANCE_AUTO_ATTACH_NONE: 'No auto attach',
  FUEL_ADVANCE_AUTO_ATTACH_ALL: 'Auto attach all',
  FUEL_ADVANCE_AUTO_ATTACH_INVOICE: 'Fuel Advance type Invoice',
  FUEL_ADVANCE_AUTO_ATTACH_CREDIT: 'Fuel Advance type Credit',
  OVER_ADVANCE_AUTO_ATTACH_TITLE: 'Over Advance Auto Attach',
  OVER_ADVANCE_AUTO_ATTACH_DESCRIPTION:
    'Pre-select open Over Advances automatically when the Approve for Funding screen opens.',
}

export const chargebackEs: typeof chargebackEn = {
  FULL: 'Completo',
  PART: 'Parcial',
  CHARGEBACKS: 'Devoluciones',
  CHARGEBACK: 'Devolución',
  APPLY_CHARGEBACK: 'Aplicar Devolución',
  APPLY_WRITE_OFF: 'Aplicar Write Off',
  CHARGEBACK_APPLICATION_CONFIRMATION: '¿Está seguro que desea aplicar esta devolución a estas facturas?',
  WRITE_OFF_APPLICATION_CONFIRMATION: '¿Está seguro que desea aplicar este Write Off a estas facturas?',
  CHARGEBACK_FA_APPLICATION_CONFIRMATION:
    '¿Está seguro que desea aplicar esta devolución a estos anticipos de combustible?',
  CHARGEBACK_ASSIGN_SUCCESSFULLY: 'Devolución asignada correctamente',
  WRITE_OFF_ASSIGN_SUCCESSFULLY: 'Write Off aplicado correctamente',
  CHARGEBACK_SELECTED_INVOICES: 'La devolución será aplicada a las siguientes facturas:',
  WRITE_OFF_SELECTED_INVOICES: 'El Write Off será aplicado a las siguientes facturas:',
  ADD_NOTES: 'Agregar notas:',
  ADD_NOTES_BUTTON: 'Agregar Notas',
  ADD_NOTES_HERE: 'Agregar notas aquí...',
  TOTAL_INVOICE_BALANCE: 'Saldo total de facturas:',
  TOTAL_CHARGEBACK_AMOUNT: 'Monto total de devoluciones:',
  TOTAL_WRITE_OFF_AMOUNT: 'Monto total de Write Off:',
  NEW_BALANCE: 'Nuevo saldo:',
  UNAPPLIED_FUND: 'Fondo no aplicado',
  NO_INVOICE_SELECTED: 'Ninguna factura seleccionada',
  ONE_INVOICE_SELECTED: 'Una factura seleccionada',
  MULTIPLE_INVOICE_SELECTED: '{amount} facturas seleccionadas',
  CONFIRM_APPLY_CHARGEBACK: 'Confirmar Devolución',
  UNDER_MESSAGE_CHARGEBACK: 'El pago total de las facturas es menor al total del pago.',
  OVER_MESSAGE_CHARGEBACK: 'El pago total de las facturas excede el total del pago.',
  OVER_MESSAGE_CHARGEBACK_AMOUNT: 'El monto total de la devolución excede el saldo total de las facturas.',
  OVER_MESSAGE_WRITE_OFF_AMOUNT: 'El monto total del Write Off excede el saldo total de las facturas.',
  TOTAL_CHARGEBACKS_AMOUNT: 'Monto Total de Devoluciones',
  TYPE: 'Tipo',
  AMOUNT: 'Monto',
  CONFIRM_APPLY_WRITE_OFF: 'Confirmar Write Off',
  WRITE_OFF_PERMISSION_REQUIRED: 'No tienes permiso para crear Write Offs.',
  WRITE_OFFS_COMING_SOON: 'Los Write Offs para anticipos de combustible estarán disponibles pronto.',
  COMING_SOON_TITLE: '¡Próximamente!',
  COMING_SOON_DESCRIPTION: 'Podrás usar esta funcionalidad en una próxima actualización.',
  //START Patricio
  FUNDING_CHARGEBACK: 'Cargo por Reembolso de Financiamiento',
  FUNDING_CHARGEBACK_INVOICE_TITLE: 'Factura - Aplicar Automáticamente Cargo por Reembolso',
  FUNDING_CHARGEBACK_INVOICE_DESCRIPTION: 'Habilitar Cargos por Reembolso en la Compra de Facturas.',
  FUNDING_CHARGEBACK_FUEL_ADVANCE_TITLE: 'Fuel Advance - Aplicar Automáticamente Cargo por Reembolso',
  FUNDING_CHARGEBACK_FUEL_ADVANCE_DESCRIPTION: 'Habilitar Cargos por Reembolso en Fuel Advance.',
  FUNDING_CHARGEBACK_MAX_AMOUNT_ALLOWED: 'El monto máximo permitido para pagar es $ {amount}.',
  CREDITS: 'Créditos',
  CREDIT_BALANCE: 'Saldo de Crédito',
  RELEASE_CREDIT: 'Liberar Crédito',
  TOTAL_CREDIT_AMOUNT: 'Monto Total de Crédito:',
  CONFIRM_RELEASE_CREDIT: 'Confirmar Liberación de Crédito',
  RELEASE_CREDIT_SUCCESSFULLY: 'Crédito liberado correctamente',
  NO_CREDITS_SELECTED: 'Ningún crédito seleccionado',
  RELEASE_CREDIT_DIALOG_DESC:
    'Está por liberar los créditos de las facturas seleccionadas a la Reserva de Efectivo del cliente como devolución. Una vez liberados, los créditos quedarán cerrados con saldo $0.00.',
  SELECTED_INVOICES_COUNT: 'Facturas seleccionadas',
  //END Patricio
  //START Michael
  CHARGEBACKS_FUEL_ADVANCES: 'Devoluciones de Anticipos de Combustible',
  CHARGEBACKS_OVER_ADVANCES: 'Devoluciones de Over Advances',
  SEARCH_FUEL_ADVANCE: 'Buscar Anticipo de Combustible',
  SEARCH_OVER_ADVANCE: 'Buscar Over Advance',
  SEARCH_CREDIT: 'Buscar Crédito',
  TOTAL_CREDITS_AMOUNT: 'Monto Total de Créditos',
  REF_NO: 'Ref no',
  //END Michael
  FUEL_ADVANCE_AUTO_ATTACH_TITLE: 'Auto Adjuntar Anticipo de Combustible',
  FUEL_ADVANCE_AUTO_ATTACH_DESCRIPTION:
    'Elige qué tipos de Anticipo de Combustible se preseleccionan al abrir la pantalla de Aprobación de Financiamiento.',
  FUEL_ADVANCE_AUTO_ATTACH_NONE: 'Sin auto adjuntar',
  FUEL_ADVANCE_AUTO_ATTACH_ALL: 'Auto adjuntar todos',
  FUEL_ADVANCE_AUTO_ATTACH_INVOICE: 'Tipo Anticipo de Combustible Factura',
  FUEL_ADVANCE_AUTO_ATTACH_CREDIT: 'Tipo Anticipo de Combustible Crédito',
  OVER_ADVANCE_AUTO_ATTACH_TITLE: 'Auto Adjuntar Over Advance',
  OVER_ADVANCE_AUTO_ATTACH_DESCRIPTION:
    'Preseleccionar automáticamente los Over Advances abiertos al abrir la pantalla de Approve for Funding.',
}
